import {Component, Input, OnInit} from '@angular/core';
import {KpiItem} from '../../../../../models/common';

@Component({
  selector: 'new-kpi-item',
  templateUrl: './new-kpi-item.component.html',
  styleUrls: ['./new-kpi-item.component.scss']
})
export class NewKpiItemComponent {
  @Input() kpi: KpiItem;
  @Input() titleTooltip: string;
  @Input() showStatus = false;
  @Input() isPercentValue = false;
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-kpi/new-kpi-item/new-kpi-item.component.ts